/**
 * @func formatPhoneNumber
 * @param {string | number} phoneNumber - raw phone number.
 * @param {Object}  [options] - Optional object with options
 * @param {boolean} [options.safe=true] - If true, an invalid phone number will return an empty string instead of throwing an error
 * @return {string} formatted phone number
 * @desc Formats phone number
 * ```ts
 * formatPhoneNumber(6318675309);
 * // returns "(631) 867-5309"
 * ```
 * @memberof module:String
 * @instance
 */
function formatPhoneNumber(phoneNumber, { safe = true } = {}) {
    const phoneNumberString = String(phoneNumber);
    const strippedPhoneNumber = phoneNumberString.replace(/[^\d]/g, '');
    // Remove 1 if it exists at the start of the phone number
    if (strippedPhoneNumber.length === 11 &&
        strippedPhoneNumber.startsWith('1')) {
        return strippedPhoneNumber
            .slice(-10, 11)
            .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    if (strippedPhoneNumber.length === 10) {
        return strippedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    if (safe)
        return '';
    throw new Error('Invalid phone number');
}

export { formatPhoneNumber as default };
